<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form inline class="inline-form">
          <el-form-item label="变动时间">
            <el-date-picker
              ref="creatTime"
              v-model="creatTime"
              type="datetimerange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="资金变动类型">
            <el-select style="width: 120px;" v-model="state" clearable>
              <el-option label="流入" value="0"></el-option>
              <el-option label="流出" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
            <auth-button
              opt="export"
              :plain="true"
              icon="el-icon-download"
              :loading="exportButtonLoading"
              @click.native="exportClick"
              label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <div class="tip-view">
          温馨提示：此账户至仅指乐刷内部账户变更记录，实际款项变更请参考银行记录
        </div>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="AccountRealTimeDealsList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="fupdateTime"
          label="变动时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fFlowId"
          label="流水号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fState"
          label="资金变动类型"
          align="center"
          min-width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.fState | formatState }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fAmount"
          label="变动金额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.fAmount / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fFailureMsg"
          label="备注"
          align="center"
          min-width="150">
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.count > 0"
        class="pagination"
        :page-size="paginations.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="paginations.count"
        :current-page="paginations.pageNo"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import { listAccountFlow, exportAccountFlow } from '@/api/settle.js'

export default {
  name: 'AccountRealTimeDeals',
  data () {
    const todayStr = parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')
    const toadyZero = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}')
    return {
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            start.setHours(0)
            start.setMinutes(0)
            start.setSeconds(0)
            const end = new Date()
            end.setHours(23)
            end.setMinutes(59)
            end.setSeconds(59)
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        state: ''
      },
      creatTime: [todayZeroStr, todayStr],
      state: '',
      tableLoading: false,
      exportButtonLoading: false,
      AccountRealTimeDealsList: []
    }
  },
  mounted () {
    this.getDefaultData()
  },
  beforeDestroy () {},
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      // this.loading = true
      // await this.getAllSubMerchantNames()
      await this.searchClick()
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      console.log('查询点击')
      this.setSearchInfoParams(noReset)
      this.listAccountFlow()
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      console.log('导出点击')
      this.setSearchInfoParams(true)
      const startDate = new Date(this.searchInfo.startTime)
      const endDate = new Date(this.searchInfo.endTime)
      if (!this.searchInfo.startTime || !this.searchInfo.endTime || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
        this.$message({
          message: '请筛选1个月内的数据进行导出',
          type: 'error'
        })
        return
      }
      this.exportAccountFlow()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.state = this.state || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
    },
    dateChange (value) {
      if (value !== null) {
        if ((value[0] === value[1])) {
          value[0] = value[0].substring(0, 10) + ' 00:00:00'
          value[1] = value[1].substring(0, 10) + ' 23:59:59'
        }
      }
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 账户流水查询
     */
    listAccountFlow () {
      // this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      listAccountFlow(params).then(response => {
        console.log('listAccountFlow response:', response)
        this.loading = false
        if (response.error_code === '0') {
          this.AccountRealTimeDealsList = response.data.list
          this.paginations.count = response.data.totalCount
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 账户流水查询导出
     */
    exportAccountFlow () {
      this.exportButtonLoading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      exportAccountFlow(params).then(response => {
        this.exportButtonLoading = false
        console.log('exportAccountFlow调用')
        // 弹出下载框
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '账户流水.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }, {
        axios_opts: {
          responseType: 'blob'
        }
      })
    },
    formatDate (item) {
      return parseTime(new Date(item.fTime), '{y}-{m}-{d} {h}:{i}:{s}')
    }
  },
  computed: {
    roleName () {
      return this.$store.getters.roleName
    }
  },
  filters: {
    formatState (value) {
      switch (value) {
        case 0:
          return '流入'
        case 1:
          return '流出'
        default:
          return '未知'
      }
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.tip-view {
  margin: 10px;
  font-size: 14px;
}
</style>
